import React from 'react';

import { IconBaseProps } from 'react-icons/lib/cjs';
import { Container } from './styles';

interface CardProps {
  description?: string;
  title: string;
  icon?: React.ComponentType<IconBaseProps>;
}

const Card: React.FC<CardProps> = ({ description, title, icon: Icon }) => {
  return (
    <Container>
      <div
        style={{
          background: '#C4C4C4',
          width: 150,
          height: 150,
          borderRadius: '50%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {Icon && <Icon size={72} color="#FFFFFF" />}
      </div>
      <strong>{title}</strong>
      <p>{description}</p>
    </Container>
  );
};

export default Card;
